import React, { createContext, useMemo, useState } from 'react'

import SurgeryWorkflowValidationResultsModal from 'components/modals/SurgeryWorkflowValidationResultsModal'

interface SurgeryWorkflowValidationFailure {
  instruction?: string | null
  requirement?: string | null
  title?: string | null
}

interface SurgeryWorkflowValidationContextValue {
  setShowSurgeryWorkflowValidationResultsModal: (isOpen: boolean) => void
  setSurgeryWorkflowValidationFailures: (
    failures: SurgeryWorkflowValidationFailure[]
  ) => void
}

const SurgeryWorkflowValidationContext =
  createContext<SurgeryWorkflowValidationContextValue>({
    setShowSurgeryWorkflowValidationResultsModal: () => {},
    setSurgeryWorkflowValidationFailures: () => {}
  })

export function SurgeryWorkflowValidationProvider({
  children
}: {
  children: React.ReactNode
}) {
  const [
    surgeryWorkflowValidationFailures,
    setSurgeryWorkflowValidationFailures
  ] = useState<SurgeryWorkflowValidationFailure[]>([])
  const [
    showSurgeryWorkflowValidationResultsModal,
    setShowSurgeryWorkflowValidationResultsModal
  ] = useState(false)

  const closeSurgeryWorkflowValidationResultsModal = () => {
    setShowSurgeryWorkflowValidationResultsModal(false)
    setSurgeryWorkflowValidationFailures([])
  }

  const contextValue = useMemo(
    () => ({
      setShowSurgeryWorkflowValidationResultsModal,
      setSurgeryWorkflowValidationFailures
    }),
    [
      setShowSurgeryWorkflowValidationResultsModal,
      setSurgeryWorkflowValidationFailures
    ]
  )

  return (
    <SurgeryWorkflowValidationContext.Provider value={contextValue}>
      {children}
      <SurgeryWorkflowValidationResultsModal
        closeComponent={closeSurgeryWorkflowValidationResultsModal}
        isOpen={showSurgeryWorkflowValidationResultsModal}
        validationFailures={surgeryWorkflowValidationFailures}
      />
    </SurgeryWorkflowValidationContext.Provider>
  )
}

export default SurgeryWorkflowValidationContext
